/**
 * Created by rkotha on 8/23/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('SignOutHomePageController', SignOutHomePageController);

    SignOutHomePageController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$sce','entities', 'NasracWebContent'];

    function SignOutHomePageController ($scope, Principal, LoginService, $state, $sce, entities,NasracWebContent) {
        var vm = this;

        var Entity = entities[0];
        $scope.contactsTrustedHtml = $sce.trustAsHtml(Entity.content);

        getAccount();

        function getAccount() {
        	var adminAuthorities = ['Administrators'];
            Principal.hasAuthority(Principal.findHasAnyAuthority(adminAuthorities)).then(function(result){
                vm.isAdmin  = result;

                if(vm.isAdmin === true && Principal.isAuthenticated()){
                    $state.go('home-main.home-page', {}, {
                        reload : false
                    });
                }
                else if(vm.isAdmin===false && Principal.isAuthenticated()){
                    $state.go('user-home-page', {}, {
                        reload : false
                    });
                }
                else{
                    $state.go('sign-out-home-page', {}, {
                        reload : false
                    });
                }
            });
        }

    }
})();
